import {
    getCachedTableDataSlice,
    getCachedTableResultSelector,
} from 'src/hooks/common-data-service/cached-table';

import {userConferencesStateSelector} from './user-conferences-state.slice';

import type {
    CachedTableCacheSelector,
    CachedTableDataSelector,
} from 'src/hooks/common-data-service/cached-table/typedef';
import type {AccountSearchCriteria} from 'src/openapi/admin/models/AccountSearchCriteria';
import type {AccountSearchResult} from 'src/openapi/admin/models/AccountSearchResult';
import type {AccountSortField} from 'src/openapi/admin/models/AccountSortField';

export const userConferencesSlice = getCachedTableDataSlice<
    AccountSearchResult[],
    AccountSearchCriteria,
    AccountSortField,
    undefined
>('userConferences');

export const userConferencesActions = userConferencesSlice.actions;
const userConferencesCacheSelector: CachedTableCacheSelector<AccountSearchResult[]>
    = state => state.userPage.tabs.userConferences.result.cache;
export const userConferencesDataSelector: CachedTableDataSelector<AccountSearchResult[]>
    = state => state.userPage.tabs.userConferences.result;
export const userConferencesResultSelector = getCachedTableResultSelector(
    userConferencesCacheSelector,
    userConferencesStateSelector,
);
